import AdminPermission from "../components/AdminPermission";
import useAdminPermission from "../hooks/useAdminPermission";


function AdminPermissionPage() {
    const UseAdminPermissionProps = useAdminPermission();
    return <AdminPermission {...UseAdminPermissionProps} />
}
export default AdminPermissionPage;